/**
 * Neutral cosmic-bg screen shown while Clerk hydrates for a returning
 * signed-in user. Avoids flashing the LandingPage (logged-out hero) before
 * HomePage swaps in. Kept intentionally minimal — the bg matches both
 * LandingPage and HomePage backdrops, so the swap is seamless.
 *
 * Extracted from App.tsx so RequireAuth shows the SAME screen; a
 * different loading state between the two would flash on guarded routes.
 */
export function AuthLoadingScreen() {
  return (
    <div className="flex items-center justify-center min-h-dvh bg-cosmic-black">
      <div
        className="w-1.5 h-1.5 rounded-full bg-gold/70 animate-pulse"
        aria-label="Loading"
        role="status"
      />
    </div>
  )
}
